<div class="chat-channel">

  @if (messages()?.length) {
    <ng-scrollbar
      class="chat-channel-scrollbar"
      [class.has-scroll]="scrollbarRef?.adapter?.isVerticallyScrollable?.()"
      (scroll)="onScroll($event)">
      <div class="chat-messages">
        @if (isLoading) {
          <mat-spinner color="primary" class="loading-spinner" [diameter]="24"></mat-spinner>
        }

        @for (item of messages(); track item.messageId) {
          <app-chat-message
            class="channel-message"
            [message]="item"
            [adapter]="chatAdapter"
            (edit)="editMessage(item)"
            (mediaLoaded)="scrollToBottom()"
            (delete)="deleteMessage(item)"
            [currentUserMessage]="item.senderId === currentUserId"
            [canDelete]="canAdministerChannel || item.senderId === currentUserId">
          </app-chat-message>
        }

        @if (loadingIndicator) {
          <div class="channel-message">
            <div class="chat-loading-message">
              {{ 'COMMON.uploading' | translate }}

              <mat-spinner class="progress-spinner-white" [diameter]="16" color="white"></mat-spinner>
            </div>
          </div>
        }
      </div>
    </ng-scrollbar>
  } @else if(!isLoading){
    <app-list-empty-state
      icon="chat-dots"
      [title]="'CHAT.no_messages' | translate">
    </app-list-empty-state>
  }

</div>
